import { createSlice } from "@reduxjs/toolkit";

export interface SellThisNowToastSliceState {
  showToast: boolean;
}

const initialState: SellThisNowToastSliceState = {
  showToast: false,
};

export const sellThisNowToastSlice = createSlice({
  name: "sellThisNowToastSlice",
  initialState,
  reducers: {
    showSellThisNowToast: (state) => {
      state.showToast = true;
      return state;
    },
    hideSellThisNowToast: (state) => {
      state.showToast = false;
      return state;
    },
  },
});

export const { showSellThisNowToast, hideSellThisNowToast } = sellThisNowToastSlice.actions;
export default sellThisNowToastSlice;
